import { connect } from 'react-redux';
import { createToolbarEvent } from '../../../analytics/AnalyticsEvents';
import { sendAnalytics } from '../../../analytics/functions';
import { isIosMobileBrowser } from '../../../base/environment/utils';
import { translate } from '../../../base/i18n/functions';
import { IconEbook } from '../../../base/icons/svg';
import AbstractButton from '../../../base/toolbox/components/AbstractButton';
/**
 * Implementation of a button for opening ebook module.
 */
class EbookButton extends AbstractButton {
    constructor() {
        super(...arguments);
        this.accessibilityLabel = 'toolbar.accessibilityLabel.ebook';
        this.label = 'toolbar.ebook';
        this.tooltip = 'toolbar.ebook';
        this.icon = IconEbook;
    }
    /**
    * Handles clicking the button, and opens ebook.
    *
    * @private
    * @returns {void}
    */
    _handleClick() {
        window.open("http://localhost:80/insider", "Supercourse eBook", "width=1280,height=720");
        sendAnalytics(createToolbarEvent('ebook'));
    }
}
/**
 * Function that maps parts of Redux state tree into component props.
 *
 * @param {Object} state - Redux state.
 * @returns {Object}
 */
const mapStateToProps = (state) => {
    return {
        _ebook: state['features/toolbox'].ebook,
        visible: !isIosMobileBrowser()
    };
};
export default translate(connect(mapStateToProps)(EbookButton));
